// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bdfc2f5d","879":"cab6df3a"}[chunkId] + ".chunk.js";
};